type Config = {
  apiHost: string
  authClientId: string
  launchDarklyId: string
  amplitudeApiKey: string
}

const prod: Config = {
  apiHost: 'api.intelecy.io',
  authClientId: '4MWOv7DTbQFjJaOM0gDNCwJZO0lQ7dMT',
  launchDarklyId: '6284dbdbbed873156be6121e',
  amplitudeApiKey: '603bb5d75cfc9a7a49b2e3e2935f32b7',
}

const dev: Config = {
  apiHost: 'api-dev.intelecy.io',
  authClientId: 'HYmLbrvBPRus3mY7twD96K3EeGbbqI9F',
  launchDarklyId: '6284dbdbbed873156be6121d',
  amplitudeApiKey: '8d2cc6f43a4b68120acc4d5600105f05',
}

const testAmplitudeApiKey = 'af3693876d342e657fa4b1223203321e'

// configure the config and stack based on the hostname
let config: Config
let stack: 'prod' | 'staging' | 'dev' | 'unknown'

switch (window.location.hostname) {
  case 'intelecy.io':
  case 'www.intelecy.io':
  case 'intelecyfront.azurewebsites.net':
  case 'intelecyfront-westeurope.azurewebsites.net':
    config = prod
    stack = 'prod'
    break

  case 'staging.intelecy.io':
  case 'intelecyfront-staging.azurewebsites.net':
  case 'intelecyfront-westeurope-staging.azurewebsites.net':
    config = prod
    stack = 'staging'
    break

  case 'dev.intelecy.io':
    config = dev
    stack = 'dev'
    break

  case 'localhost':
  default:
    // only used with `yarn run start-prod-api`
    if (window.location.port === '5173') {
      config = {
        ...prod,
        amplitudeApiKey: testAmplitudeApiKey,
      }
      stack = 'prod'
      break
    }

    config = {
      ...dev,
      amplitudeApiKey: testAmplitudeApiKey,
    }
    stack = 'unknown'
    break
}

export const STACK = stack
export const API_ROOT = `https://${config.apiHost}`
export const WS_ROOT = `wss://${config.apiHost}`
export const AUTH_CLIENT_ID = config.authClientId
export const LAUNCH_DARKLY_ID = config.launchDarklyId
export const AMPLITUDE_API_KEY = config.amplitudeApiKey
